<ion-header class="ion-no-border">
  <ion-toolbar color="light">
    <ion-buttons slot="end">
      <ion-button size="small" role="link" color="primary" (click)="skip()">
        {{ 'onboarding.step.skip' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <app-loader [loading]="!projectsLoaded" [full]="true"></app-loader>
  <div class="app__content address" *ngIf="projectsLoaded">
    <div class="address__content suggestions">
      <div class="address__content__top">
        <ng-container *ngIf="!noAddresses; else noLocation">
          <h1>{{ 'suggestion.title' | translate }}</h1>
          <p>{{ 'suggestion.description' | translate }}</p>
        </ng-container>
        <ng-template #noLocation>
          <h1>
            {{ 'suggestion.title.noLocation' | translate:{appName: appName} }}
          </h1>
          <p>{{ 'suggestion.description.noLocation' | translate }}</p>
        </ng-template>
      </div>

      <div class="address__content__results">
        <app-search-item
          [loading]="false"
          [detailsBlocked]="true"
          [withDistance]="project.item.distance"
          *ngFor="let project of suggestions"
          [location]="project.location"
          [project]="project.item"
          (waiting)="disable()"
          [pickingTarget]="pickingTarget"
        ></app-search-item>
        <app-search-empty
          *ngIf="suggestions.length == 0 && projectsLoaded"
        ></app-search-empty>
        <app-loader [full]="false" [loading]="!projectsLoaded"></app-loader>
      </div>
    </div>

    <div class="address__footer">
      <button class="address__footer__button--secondary" (click)="search()">
        {{ 'suggestion.step.search' | translate }}
      </button>
      <button
        class="address__footer__button"
        [attr.disabled]="disabledCount > 0 ? true : null"
        (click)="complete()"
      >
        {{ 'suggestion.step.complete' | translate }}
      </button>
    </div>
  </div>
</ion-content>
